import {
  type ListDirectionMode,
  type PropertiesConfigInputListFieldModel,
} from '@blaze-shared/elements-domain';

export type ListFieldSlot =
  | 'Image'
  | 'Heading'
  | 'Description'
  | 'Name'
  | 'Message'
  | 'IsUnread'
  | 'Timestamp'
  | 'Title'
  | 'Price'
  | 'BulletList'
  | 'ItemName'
  | 'ItemDescription'
  | 'ItemPrice'
  | 'OriginalPrice'
  | 'Rating'
  | 'RatingVotes'
  | 'Badge'
  | 'Callout';

export const SLOT_TO_FIELD_KEY: Record<ListFieldSlot, keyof PropertiesConfigInputListFieldModel> = {
  Image: 'image',
  Heading: 'heading',
  Description: 'description',
  Name: 'name',
  Message: 'message',
  IsUnread: 'isUnread',
  Timestamp: 'timestamp',
  Title: 'title',
  Price: 'price',
  BulletList: 'bulletList',
  ItemName: 'itemName',
  ItemDescription: 'itemDescription',
  ItemPrice: 'itemPrice',
  OriginalPrice: 'originalPrice',
  Rating: 'rating',
  RatingVotes: 'ratingVotes',
  Badge: 'badge',
  Callout: 'callout',
};

const TEMPLATE_SLOTS: Record<ListDirectionMode, ReadonlySet<ListFieldSlot>> = {
  vertical: new Set(['Image', 'Heading', 'Description']),
  horizontal: new Set(['Image', 'Heading', 'Description']),
  notification: new Set(['Image', 'Name', 'Message', 'IsUnread', 'Timestamp']),
  'subscription-plan': new Set(['Image', 'Title', 'Price', 'BulletList']),
  'e-commerce': new Set([
    'Image',
    'ItemName',
    'ItemDescription',
    'ItemPrice',
    'OriginalPrice',
    'Rating',
    'RatingVotes',
    'Badge',
    'Callout',
  ]),
  // html has no slots at all — every mapping demotes to a custom field.
  custom: new Set(),
};

export function isSlotForDirection(direction: ListDirectionMode, slot: ListFieldSlot): boolean {
  return TEMPLATE_SLOTS[direction].has(slot);
}
